/**
 * Bike Bell – Core component
 */
var BikeBell = (function () {
    'use strict';

    function BikeBell() {
        waitForOwl();
    }

    function waitForOwl() {
        var check = setInterval(function () {
            if (jQuery.fn.owlCarousel) {
                clearInterval(check);
                initCarousel();
            }
        }, 50);
    }

    function initCarousel() {
        var $carousel = jQuery('.bikebell-carousel__slider');
        if (!$carousel.length) {
            return;
        }

        $carousel.owlCarousel({
            items: 1,
            margin: 0,
            loop: true,
            nav: true,
            navText: [
                '<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="35.5" cy="35.5" r="35.5" transform="rotate(-180 35.5 35.5)" fill="#D9D9D9"/> <path d="M16.5858 33.5858C15.8047 34.3668 15.8047 35.6332 16.5858 36.4142L29.3137 49.1421C30.0948 49.9232 31.3611 49.9232 32.1421 49.1421C32.9232 48.3611 32.9232 47.0948 32.1421 46.3137L20.8284 35L32.1421 23.6863C32.9232 22.9052 32.9232 21.6389 32.1421 20.8579C31.3611 20.0768 30.0948 20.0768 29.3137 20.8579L16.5858 33.5858ZM56 35L56 33L18 33L18 35L18 37L56 37L56 35Z" fill="black"/> </svg>',
                '<svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="35.5" cy="35.5" r="35.5" transform="rotate(-180 35.5 35.5)" fill="#D9D9D9"/> <path d="M16.5858 33.5858C15.8047 34.3668 15.8047 35.6332 16.5858 36.4142L29.3137 49.1421C30.0948 49.9232 31.3611 49.9232 32.1421 49.1421C32.9232 48.3611 32.9232 47.0948 32.1421 46.3137L20.8284 35L32.1421 23.6863C32.9232 22.9052 32.9232 21.6389 32.1421 20.8579C31.3611 20.0768 30.0948 20.0768 29.3137 20.8579L16.5858 33.5858ZM56 35L56 33L18 33L18 35L18 37L56 37L56 35Z" fill="black"/> </svg>'
            ],
            dots: true,
            autoplay: false,
        });
    }

    return BikeBell;
})();
